import React from "react";
import "../../assets/styles/table.css";
import { useNavigate } from 'react-router-dom';

const TableGrid = ({ items, data, column, moduleName, handleEdit, handleDelete, menuRights, handleStatusOpen, handleView, requestSort, sortConfig }) => {
  const getClassNamesFor = (value) => {
    if (!sortConfig) {
      return;
    }
    return sortConfig.key === value ? sortConfig.direction : undefined;
  };
  const navigate = useNavigate();
  const navigateToForecast = () => {
    navigate('/forecast');
  };

  const handleColumnClick = (e, index, item) => {
    if (menuRights?.canView === true && index == 0 && (moduleName == 'deliveryterms' || moduleName == 'paymentterms' || moduleName == 'distributor' || moduleName == 'enquiry' || moduleName == 'userrole' || moduleName == 'customer' || moduleName == 'customer' || moduleName == 'company' || moduleName == 'project' || moduleName == 'User')) handleView(item)
  }
  return (
    <>
      <section className="table-sec">
        <div>
          <table className="table table-striped table-borderless">
            <thead>
              <tr> {column?.map((item, index) => (
                <th scope="col" className={getClassNamesFor(item.value)} onClick={index === 0 ? () => requestSort(item.value) : undefined}>
                  {item.heading}{" "}{index === 0 && <i className="fas fa-sort" />}
                </th>))}
                {menuRights?.canEdit === true || menuRights?.canDelete === true || moduleName === "General master" || moduleName === "General List" ? <th className="text-center">Action</th> : null}
              </tr>
            </thead>
            <tbody>
              {items?.map((item, index) => (
                <>
                  <tr>
                    {column?.map((columnItem, index) => {
                      return (
                        <>
                          <td dangerouslySetInnerHTML={{ __html: item[`${columnItem.value}`]}}
                            className={`text-align ${
                            columnItem?.heading === "Status" && item?.isActive === true
                              ? "status-active"
                              : columnItem?.heading === "Status" && item?.isActive === false
                              ? "status-inactive"
                              : columnItem?.heading === "Due Date" &&
                                item?.[columnItem?.className] === "INACTIVE"
                              ? "inactive"
                              : ""
                          } ${item?.view === "VIEW" && index === 0 ? "table-view" : ""}`}
                            onClick={(e) => handleColumnClick(e, index, item)}>
                          </td>
                        </>);
                    })}

                    <td className="text-center"> {moduleName === "General master" ?
                      <span> <i className="far fa-edit" title="View" onClick={() => { handleEdit(item, index) }}></i></span> : <>
                        {menuRights?.canEdit === true || (moduleName !== "company"
                          && moduleName !== "project" && moduleName !== "distributor" && moduleName !== "customer" && moduleName !== "User" && moduleName !== "deliveryterms" && moduleName !== "paymentterms" && moduleName !== "userrole" && moduleName !== "enquiry") ? <span>
                          <i className="far fa-edit mr-2" title="Edit" onClick={() => { handleEdit(item, index) }}></i>
                        </span> : ""}
                        {moduleName === "User" ? "" : menuRights?.canDelete === true || (moduleName !== "company" && moduleName !== "project" && moduleName !== "distributor" && moduleName !== "customer" && moduleName !== "deliveryterms" && moduleName !== "paymentterms" && moduleName !== "userrole" && moduleName !== "enquiry") ?
                          <span>
                            <i className="far fa-trash-alt" onClick={() => { handleDelete(item) }} title="Delete"></i>
                          </span> : ""}
                      </>}
                    </td>
                  </tr>
                </>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </>
  );
};

export default TableGrid;


